
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sources/kafka",
      function () {
        return require("private-next-pages/events/sources/kafka.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sources/kafka"])
      });
    }
  